/**
 * @template T
 */
export class Hook {

    /**
     * @type {function[]}
     * @private
     */
    _listeners = [];

    /**
     * @type {boolean}
     * @private
     */
    _isMuted = false;

    /**
     * @param {function} listener
     */
    listen(listener) {
        this._listeners.push(listener);
    }

    /**
     * Fire the hook with any args
     */
    fire() {
        if (this._isMuted) {
            return;
        }
        this._listeners.forEach( listener => {
            listener.apply(null, arguments);
        });
    }

    /**
     * @param {Hook} other
     */
    forward(other) {
        this.listen( (...args) => other.fire(...args));
    }

    /**
     * Remove a listener, returns true if it was actually found and removed.
     * @param {function} listener
     * @return {boolean}
     * @deprecated use self::delete()
     */
    remove(listener) {
        const idx = this._listeners.indexOf(listener);
        if (idx === -1) {
            throw new Error(`listener does not exist: ${listener}`);
        }
        this._listeners.splice(idx, 1);
    }

    /**
     * Remove a listener, returns true if it was actually found and removed.
     *
     * @param {function} listener
     * @return {boolean}
     */
    delete(listener) {
        const idx = this._listeners.indexOf(listener);
        if (idx === -1) {
            return false;
        }
        return this._listeners.splice(idx, 1).length > 0;
    }

    clear() {
        this._listeners = [];
    }

    /**
     * @return {boolean}
     */
    isMuted() {
        return this._isMuted;
    }

    /**
     * Mute it, do not fire any events
     * @param muted
     */
    mute(muted=true) {
        this._isMuted = muted;
    }

    unMute(unMuted=true) {
        this.mute(!unMuted);
    }

    /**
     * @param {function} listener
     * @return {number}
     */
    indexOf(listener) {
        return this._listeners.indexOf(listener);
    }
}